import { useState } from "react";
import { createHeaders } from "@project-mgmt/api-client";
export function useDismissNotification(workspaceId) {
    const [isLoading, setIsLoading] = useState(false);
    const dismissNotification = async (notificationId) => {
        setIsLoading(true);
        try {
            const response = await fetch(`/api/notifications/${notificationId}`, {
                method: "DELETE",
                headers: createHeaders(workspaceId),
            });
            if (!response.ok) {
                throw new Error("Failed to dismiss notification");
            }
            return response.json();
        }
        catch (error) {
            console.error("Error dismissing notification:", error);
            throw error;
        }
        finally {
            setIsLoading(false);
        }
    };
    return {
        dismissNotification,
        isLoading,
    };
}
